import api from "./API";
import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import cookie from "react-cookies";

export const Facebook = async (
  fbq_token,
  pixel,
  // detail_id,
  event_id,
  eventname,
  customdata,
  userdata = {
    em: "",
    ph: "",
    fn: "",
    ln: "",
    ct: "",
    st: "",
    zp: "",
    country: "",
    external_id: "",
    client_ip_address: "",
    client_user_agent: "",
    fbc: "",
    fbp: "",
    lead_id: "",
    anon_id: "",
    madid: "",
    page_id: "",
    page_scoped_user_id: "",
    ctwa_clid: "",
    ig_account_id: "",
    ig_sid: "",
  },
  orderNu
) => {
  let _fbc = cookie.load("_fbc", { path: "/" });
  let _fbp = cookie.load("_fbp", { path: "/" });
  _fbc = _fbc ? _fbc : "";
  _fbp = _fbp ? _fbp : "";
  userdata["fbc"] = _fbc;
  userdata["fbp"] = _fbp;

  if (!userdata.client_ip_address) {
    delete userdata.client_ip_address;
  }
  if (!userdata.client_user_agent) {
    delete userdata.client_user_agent;
  }

  return api.post(`${ApiEndpointConstants.FACEBOOK}`, {
    event_id: event_id,
    eventname: eventname,
    customdata: customdata,
    userdata: userdata,
    fbqToken: fbq_token,
    pixel: pixel,
    orderNu: orderNu,
  });
};
